import React from 'react';
import PropTypes from 'prop-types';
import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import FormControl from '@material-ui/core/FormControl';
import LockIcon from '@material-ui/icons/LockOutlined';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import { Form, Field } from 'redux-form';

import { RenderTextField as TextField } from '../formInputs';
import { email } from '../utils/validations';

import withStyles from '@material-ui/core/styles/withStyles';

const styles = theme => ({
  main: {
    width: 'auto',
    display: 'block', // Fix IE 11 issue.
    marginLeft: theme.spacing.unit * 3,
    marginRight: theme.spacing.unit * 3,
    [theme.breakpoints.up(400 + theme.spacing.unit * 3 * 2)]: {
      width: 400,
      marginLeft: 'auto',
      marginRight: 'auto',
    },
  },
  paper: {
    marginTop: theme.spacing.unit * 8,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: `${theme.spacing.unit * 2}px ${theme.spacing.unit * 3}px ${theme.spacing.unit * 3}px`,
  },
  avatar: {
    margin: theme.spacing.unit,
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing.unit,
  },
  submit: {
    marginTop: theme.spacing.unit * 3,
  },
  error: {
    marginTop: theme.spacing.unit,
    color: '#ff0000'
  }
});

function SignInForm(props) {
  const { classes, onLogin, handleSubmit, submitting, error } = props;
  return (
    <main className={classes.main}>
      <CssBaseline />
      <Paper className={classes.paper}>
        <Avatar className={classes.avatar}>
          <LockIcon />
        </Avatar>
        <Typography component="h1" variant="h5">
          Sign in
        </Typography>
        <Form className={classes.form} onSubmit={handleSubmit(onLogin)}>
          <FormControl margin="normal" required fullWidth>
            <Field 
              name="email" 
              component={TextField} 
              label="Email" 
              required
              validate={email}
            />
          </FormControl>
          <FormControl margin="normal" required fullWidth>
            <Field name="password" type="password" component={TextField} label="Password" required/>
          </FormControl>
          <Button
            type="submit"
            fullWidth
            variant="contained"
            color="primary"
            className={classes.submit}
            disabled={submitting}
          >
            Sign in
          </Button>
        </Form>
        <Typography variant="subtitle2" gutterBottom className={classes.error}>
          {error}
        </Typography>
      </Paper>
    </main>
  );
}

SignInForm.propTypes = {
  classes: PropTypes.object.isRequired,
  handleSubmit: PropTypes.func
};

export default withStyles(styles)(SignInForm);